import styled from "@emotion/styled"
import { Link } from "gatsby"
import { DialogContent, DialogOverlay } from "@reach/dialog"
import { transparentize, readableColor } from "polished"
import { animated } from "react-spring"

import { rhythm, scale } from "@utils/typography"

export const Overlay = styled(animated(DialogOverlay))`
  background: ${props => transparentize(0.05, props.theme.colours.primary)};
`

export const OverlayContent = styled(DialogContent)`
  align-items: center;
  background: none;
  display: flex;
  flex-direction: column;
  height: calc(100% - 20vh);
  justify-content: center;
  width: 100%;

  & > button {
    color: ${props => readableColor(props.theme.colours.primary)};
    font-size: ${scale(1 / 2)};
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
`

export const MenuItem = styled(animated(Link))`
  color: ${props => readableColor(props.theme.colours.primary)};
  ${scale(1 / 4)};
  margin-bottom: ${rhythm(1)};
  padding: ${rhythm(1 / 5)} 0;
  position: relative;
  text-align: center;
  text-decoration: none;

  ${props => props.theme.mq[2]} {
    ${scale(1 / 2)};
  }

  &:after {
    bottom: 0;
    content: "";
    border-bottom: 2px solid currentColor;
    display: block;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    transition: width 100ms ease;
    width: 80%;
  }

  @media (prefers-reduced-motion: no-preference) {
    &:after {
      transition: none;
    }
  }

  &:hover,
  &:focus {
    text-decoration: none;

    &:after {
      width: 30%;
    }
  }
`
